import React, {useEffect, useState} from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import {ResponseResultCode} from "app/model/response-api";
import { numberFormatter } from "app/utils/stringUtil";
import {DbUserService} from "app/services/db/dbUserService";
import { HighchartsOptionsUtil } from "app/utils/highchartsOptionsUtil";
import CountUp from "react-countup";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

const defaultPPAOption: Highcharts.Options = {
  chart: {
    type: 'pie',
    height: 270,
    spacing: [20, 0, 0, 0],
    margin: [0, 0, 35, 0],
  },
  colors: ['#44C5DB', '#9F92FF'],
  legend: {
    floating: true,
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: -24,
    padding: 0,
    borderWidth: 0,
    symbolHeight: 0,
    symbolPadding: 0,
    itemDistance: 0,
    useHTML: true,
    labelFormatter(this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-size:.8rem;font-weight:500;">${this.name}&nbsp;</span>
          <span style="font-size:.8rem;font-weight:700;">${numberFormatter(this.y)}건</span>
        </div>
      `;
    }
  },
  subtitle: {
    align: 'center',
    verticalAlign: 'middle',
    useHTML: true,
    y: -15,
    text: `
      <div style="text-align: center;">
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0건</span><br/>
        <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top: .2rem; display: inline-block;">PPA</span>
      </div>
      `,
  },
  tooltip: {
    useHTML: true,
    formatter: function (this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-weight:500;">${this.key}:&nbsp;</span>
          <span style="font-weight:700;">${numberFormatter(this.y)}</span> 건
          (<span style="font-weight:500;">${numberFormatter(this.percentage, 2)}%</span>)
        </div>
      `;
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: "72%",
      size: "85%",
      borderWidth: 0.5,
      borderRadius: 0,
    },
    series: {
      showInLegend: true,
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
    },
  },
  series: [{
    type: 'pie',
    name: 'PPA',
    data: [{ name: '완료', y: 0, }, { name: '진행', y: 0, }]
  }],
  responsive: {
    rules: [{
      condition: { maxWidth: 200 },
      chartOptions: {
        chart: { spacingTop: 20 },
        subtitle: {
          align: 'center',
          verticalAlign: 'middle',
          useHTML: true,
          y: -15,
          text: `
            <div style="text-align: center;">
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0</span><br/>
              <span style="color: #444; font-size: 1rem; font-weight: 700;">PPA</span>
            </div>
          `,
        },
        tooltip: { enabled: false }
      }
    }]
  }
};

const defaultRECOption: Highcharts.Options = {
  chart: {
    type: 'pie',
    height: 270,
    spacing: [20, 0, 0, 0],
    margin: [0, 0, 35, 0],
  },
  colors: ['#44C5DB', '#9F92FF'],
  legend: {
    floating: true,
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: -24,
    padding: 0,
    borderWidth: 0,
    symbolHeight: 0,
    symbolPadding: 0,
    itemDistance: 0,
    useHTML: true,
    labelFormatter(this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-size:.8rem;font-weight:500;">${this.name}&nbsp;</span>
          <span style="font-size:.8rem;font-weight:700;">${numberFormatter(this.y)}건</span>
        </div>
      `;
    }
  },
  subtitle: {
    align: 'center',
    verticalAlign: 'middle',
    useHTML: true,
    y: -15,
    text: `
      <div style="text-align: center;">
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0건</span><br/>
        <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top: .2rem; display: inline-block;">REC</span>
      </div>
      `,
  },
  tooltip: {
    useHTML: true,
    formatter: function (this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-weight:500;">${this.key}:&nbsp;</span>
          <span style="font-weight:700;">${numberFormatter(this.y)}</span> 건
          (<span style="font-weight:500;">${numberFormatter(this.percentage, 2)}%</span>)
        </div>
      `;
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: "72%",
      size: "85%",
      borderWidth: 0.5,
      borderRadius: 0,
    },
    series: {
      showInLegend: true,
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
    },
  },
  series: [{
    type: 'pie',
    name: 'REC',
    data: [{ name: '완료', y: 4, }, { name: '진행', y: 7, }]
  }],
  responsive: {
    rules: [{
      condition: { maxWidth: 200 },
      chartOptions: {
        chart: { spacingTop: 20 },
        subtitle: {
          align: 'center',
          verticalAlign: 'middle',
          useHTML: true,
          y: -15,
          text: `
            <div style="text-align: center;">
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0</span><br/>
              <span style="color: #444; font-size: 1rem; font-weight: 700;">REC</span>
            </div>
          `,
        },
        tooltip: { enabled: false }
      }
    }]
  }
};

const defaultEMSOption: Highcharts.Options = {
  chart: {
    type: 'pie',
    height: 270,
    spacing: [20, 0, 0, 0],
    margin: [0, 0, 35, 0],
  },
  colors: ['#44C5DB', '#9F92FF'],
  legend: {
    floating: true,
    layout: 'horizontal',
    verticalAlign: 'bottom',
    y: -24,
    padding: 0,
    borderWidth: 0,
    symbolHeight: 0,
    symbolPadding: 0,
    itemDistance: 0,
    useHTML: true,
    labelFormatter(this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-size:.8rem;font-weight:500;">${this.name}&nbsp;</span>
          <span style="font-size:.8rem;font-weight:700;">${numberFormatter(this.y)}건</span>
        </div>
      `;
    }
  },
  subtitle: {
    align: 'center',
    verticalAlign: 'middle',
    useHTML: true,
    y: -15,
    text: `
      <div style="text-align: center;">
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
        <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0건</span><br/>
        <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top: .2rem; display: inline-block;">배출권</span>
      </div>
      `,
  },
  tooltip: {
    useHTML: true,
    formatter: function (this: any) {
      return `
        <div>
          <span style="color:${this.color};">●&nbsp;</span>
          <span style="font-weight:500;">${this.key}:&nbsp;</span>
          <span style="font-weight:700;">${numberFormatter(this.y)}</span> 건
          (<span style="font-weight:500;">${numberFormatter(this.percentage, 2)}%</span>)
        </div>
      `;
    }
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      innerSize: "72%",
      size: "85%",
      borderWidth: 0.5,
      borderRadius: 0,
    },
    series: {
      showInLegend: true,
      borderWidth: 0,
      dataLabels: {
        enabled: false,
      },
    },
  },
  series: [{
    type: 'pie',
    name: '배출권',
    data: [{ name: '완료', y: 0, }, { name: '진행', y: 0, }]
  }],
  responsive: {
    rules: [{
      condition: { maxWidth: 200 },
      chartOptions: {
        chart: { spacingTop: 20 },
        subtitle: {
          align: 'center',
          verticalAlign: 'middle',
          useHTML: true,
          y: -15,
          text: `
            <div style="text-align: center;">
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
              <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">0</span><br/>
              <span style="color: #444; font-size: 1rem; font-weight: 700;">배출권</span>
            </div>
          `,
        },
        tooltip: { enabled: false }
      }
    }]
  }
};

export default function TrdPrcnd(props: Readonly<DashboardModuleProps>) {
  Highcharts.setOptions({
    ...HighchartsOptionsUtil.locale.kr.globalOptions,
    title: { text: "" },
    exporting: {enabled: false},
    credits: {enabled: false},
    tooltip: {shared: true, headerFormat: ''},
    accessibility: {enabled: false},
  });

  const [drawChartA, setDrawChartA] = useState<any>(defaultPPAOption);
  const [drawChartB, setDrawChartB] = useState<any>(defaultRECOption);
  const [drawChartC, setDrawChartC] = useState<any>(defaultEMSOption);
  const [ppaCnt, setPPACnt] = useState<number>(0);
  const [recCnt, setRECCnt] = useState<number>(0);
  const [emsCnt, setEMSCnt] = useState<number>(0);

  useEffect(() => {
    getPPATrdCnt();
    getRECTrdCnt();
    getEMSTrdCnt();
  }, []);

  function makeSubtitle(total: number, type: string) {
    return {
      align: 'center',
      verticalAlign: 'middle',
      useHTML: true,
      y: -15,
      text: `
        <div style="text-align: center;">
          <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">전체</span><br/>
          <span style="color: #828282; font-size: 0.8rem; font-weight: 600;">
            ${numberFormatter(total)}건
          </span><br/>
          <span style="color: #444; font-size: 1rem; font-weight: 700; margin-top:.1rem; display: inline-block;">
            ${type}
          </span>
        </div>
      `,
    };
  }

  function getPPATrdCnt() {
    DbUserService.getInstance().getPPATrdCnt()
    .then((response) => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        setPPACnt(response.data.qnt ?? 0);
        const progress: number = response.data.trdComplete ?? 0;
        const complete: number = response.data.trdProgress ?? 0;
        setDrawChartA({
          ...defaultPPAOption,
          subtitle: makeSubtitle(response.data.trdTotal ?? 0, 'PPA'),
          series: [{
            type: 'pie',
            name: 'PPA',
            data: [{
              name: '완료', y: progress,
            }, {
              name: '진행', y: complete,
            }],
            borderWidth: complete + progress === 0 ? 0.5 : 0,
          }]
        });
      } else {
        setPPACnt(0);
        setDrawChartA(defaultPPAOption);
      }
    })
    .catch(() => {
      setPPACnt(0);
      setDrawChartA(defaultPPAOption);
    });
  }

  function getRECTrdCnt() {
    DbUserService.getInstance().getRECTrdCnt()
    .then((response) => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        const progress: number = response.data.progress ?? 0;
        const complete: number = response.data.complete ?? 0;
        setRECCnt(response.data.trdQnt ?? 0);
        setDrawChartB({
          ...defaultRECOption,
          subtitle: makeSubtitle((progress + complete), 'REC'),
          series: [{
            type: 'pie',
            name: 'REC',
            data: [{ name: '완료', y: complete }, { name: '진행', y: progress }],
            borderWidth: complete + progress === 0 ? 0.5 : 0
          }],
          borderWidth:0,
        });
      } else {
        setRECCnt(0);
        setDrawChartB(defaultRECOption);
      }
    })
    .catch(() => {
      setRECCnt(0);
      setDrawChartB(defaultRECOption);
    });
  }

  function getEMSTrdCnt() {
    DbUserService.getInstance().getEMSTrdCnt()
    .then((response) => {
      if (response && ResponseResultCode.Y === response.resultCode) {
        const progress: number = response.data.progress ?? 0;
        const complete: number = response.data.complete ?? 0;
        setEMSCnt(response.data.trdQnt ?? 0);
        setDrawChartC({
          ...defaultEMSOption,
          subtitle: makeSubtitle((progress + complete), '배출권'),
          series: [{
            type: 'pie',
            name: '배출권',
            data: [{ name: '완료', y: complete }, { name: '진행', y: progress },],
            borderWidth: complete + progress === 0 ? 0.5 : 0
          }],
        });
      } else {
        setEMSCnt(0);
        setDrawChartC(defaultEMSOption);
      }
    })
    .catch(() => {
      setEMSCnt(0);
      setDrawChartC(defaultEMSOption);
    })
  }

  return (
    <DashboardCard
      title="거래 현황"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={false}
      dashboardConfig={props.dashboardConfig}
    >
      <div style={{display:"flex", flexWrap:'wrap',}}>
        <div className="col-4">
          <div className="graph-area">
            <div className="chart">
              {drawChartA && (
                <HighchartsReact highcharts={Highcharts} options={drawChartA}/>
              )}
            </div>
          </div>
          <div className="box-solo">
            <div className="inner">
              <p>재생에너지 공급량</p>
              <strong className="c-num">
                <CountUp end={ppaCnt ?? 0} duration={0.5}>
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp>kWh
              </strong>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="graph-area">
            <div className="chart">
              {drawChartB && (
                <HighchartsReact highcharts={Highcharts} options={drawChartB}/>
              )}
            </div>
          </div>
          <div className="box-solo">
            <div className="inner">
              <p>재생에너지 전환가능 실적</p>
              <strong className="c-num">
                <CountUp end={recCnt ?? 0} duration={0.5}>
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp>MWh
              </strong>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="graph-area">
            <div className="chart">
              {drawChartC && (
                <HighchartsReact highcharts={Highcharts} options={drawChartC}/>
              )}
            </div>
          </div>
          <div className="box-solo">
            <div className="inner">
              <p>온실가스 전환가능 실적</p>
              <strong className="c-num">
                <CountUp end={emsCnt ?? 0} duration={0.5}>
                  {({ countUpRef }) => <em ref={countUpRef} />}
                </CountUp>tCO₂
              </strong>
            </div>
          </div>
        </div>
      </div>
    </DashboardCard>
  );
}